export default "__VITE_ASSET__d2f9f501__"